import { brand } from 'config';

export const getBcomTierName = (fullTierName = '') => {
  if (!fullTierName) {
    return '';
  }

  switch (true) {
    case fullTierName.includes('BASE'):
      return 'loyallist';
    case fullTierName.includes('TOL'):
      return 'tol';
    case fullTierName.includes('UNL'):
      return 'tolunlocked';
    default:
      return '';
  }
};

export const normalizeRewardsData = (data) => {
  if (!data) {
    return {};
  }
  if (brand === 'mcom') {
    const {
      tierInfo: { tierName: tierNameUpperCased = '', tierExpiryDate, yearToDateSpend } = {},
      rewardsInfo: { currentPoints = 0, pointsThresholdForAward = 0 } = {},
    } = data;
    const tierName = tierNameUpperCased.toLowerCase();
    return {
      tierName,
      currentPoints,
      pointsThresholdForAward,
      tierExpiryDate,
      yearToDateSpend,
    };
  }
  // bcom
  const { loyalty = {} } = data;
  const { tierInfo = {}, points = {}, program = {} } = loyalty;
  const { tierName: fullTierName, tierExpiryDate } = tierInfo;
  const tierName = getBcomTierName(fullTierName);
  const { totalAvailablePoints, pointsToNextAward } = points;
  const { rewardThresholdForAward } = program;

  return {
    tierName,
    tierExpiryDate,
    currentPoints: totalAvailablePoints?.replace(/,/g, ''),
    pointsThresholdForAward: rewardThresholdForAward,
    pointsToNextAward,
  };
};

export const BANNER_KEYS = {
  desktop: 'STARREWARDS_BANNER_MY_ACCOUNT_DESKTOP',
  tablet: 'STARREWARDS_BANNER_MY_ACCOUNT_TABLET',
  mobile: 'STARREWARDS_BANNER_MY_ACCOUNT_MEW',
};

export const getFlourishBannerFlags = (banners = {}) => {
  const combined = Object.values(BANNER_KEYS)
    .map((key) => banners?.[key] || '')
    .join('')
    .toLowerCase();
  return {
    hasAnyBanner: combined.includes('nov') || combined.includes('dec'),
    isNovember: combined.includes('nov'),
    isDecember: combined.includes('dec'),
  };
};
